var React = require('react');

function Missing (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.5 2C7.43 2 9 3.57 9 5.5S7.43 9 5.5 9 2 7.43 2 5.5 3.57 2 5.5 2m0-2a5.5 5.5 0 100 11 5.5 5.5 0 100-11z"}));
}

Missing.defaultProps = {"width":"11","height":"11","viewBox":"0 0 11 11"};

module.exports = Missing;

Missing.default = Missing;
